import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueMq from 'vue-mq'
import LazyLoadDirective from './components/LazyDirective'
import VueLazyload from 'vue-lazyload'

Vue.use(VueLazyload, {
  preLoad: 1.3,
  observer: true,
  attempt: 1
})

Vue.directive('lazyload', LazyLoadDirective)
Vue.config.productionTip = false

Vue.use(VueMq, {
  breakpoints: {
    sm: 800,
    lg: Infinity
  }
})

const app = new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})

export default app
